import { post } from "../../service/api";

const CreatePos = async (body) => {
  try {
    const response = await post(`/pos`, body);
    return response;
  } catch (error) {
    console.error("Error CreatePos:", error);
    throw error;
  }
};

export default CreatePos;
